import { DaoModel } from '@dynameat/models';
import { dateToUnixSeconds, timeToUnixSeconds } from '@core/helpers';

export class Service extends DaoModel {
  static midnight = new Date('1970-01-01 23:59:59').getTime();

  constructor(guid, name, timeFrom, timeTo) {
    super(guid);
    this.name = name || '';
    this.timeFrom = timeToUnixSeconds(timeFrom);
    this.timeTo = timeToUnixSeconds(timeTo);
  }

  static toInstance(props = {}) {
    return new Service(props.guid, props.name, props.time_from, props.time_to);
  }

  isBetweenTime(datetime) {
    const time = dateToUnixSeconds(datetime);
    const timeIsBetweenFromAndTo = time >= this.timeFrom && time <= this.timeTo;
    const timeCrossesMidnight = this.timeFrom >= this.timeTo;
    const timeIsBetweenFromAndMidnight = time >= this.timeFrom && time <= Service.midnight;
    const timeIsBetweenMidnightAndTo = Service.midnight >= time && time <= this.timeTo;
    const timeIsBetweenFromOrToAcrossMidnight = timeCrossesMidnight && (timeIsBetweenFromAndMidnight || timeIsBetweenMidnightAndTo);
    return timeIsBetweenFromAndTo || timeIsBetweenFromOrToAcrossMidnight;
  }

  isBeforeTime(datetime) {
    const time = dateToUnixSeconds(datetime);
    return time < this.timeFrom;
  }

  serialize() {
    return {
      ...super.serialize(),
      name: this.name,
    };
  }
}
